var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{attrs:{"action":_vm.uploadUrl,"before-upload":_vm.beforeUpload,"on-success":_vm.successHandle,"show-file-list":false,"on-error":_vm.errorHandle,"data":_vm.params}},[_c('el-button',{attrs:{"type":"warning","size":"mini","icon":"el-icon-upload"}},[_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }